import React from "react";
import { Link } from "gatsby";
import routes from "../routes";
import { useCategories } from "../hooks/useCategories";
export default function CategoryBlocks() {
  const categories = useCategories();
  return (
    <section className="categories container">
      <div className="flex flex-wrap -mx-2 mb-8">
        {categories.map(({ slug, name }) => (
          <div className=" w-full md:w-1/2 lg:w-1/3 xl:w-1/4 p-1" key={slug}>
            <Link
              className="w-full flex items-end p-4 md:p-6 h-40 bg-primary hover:bg-primary-dark transition"
              to={`${routes.blog}/${slug}/`}
            >
              <h2 className="w-full text-white text-3xl leading-tight font-bold">{name}</h2>
            </Link>
          </div>
        ))}
      </div>
    </section>
  );
}
